import { createReducer, on, State, Action } from '@ngrx/store';

import { IMedicalLeave } from '@shared/interfaces/medical-leave.interface';
import { IParametersAssign } from '@shared/interfaces/parameters-assign-lm';
import { IUser } from '@shared/interfaces/user.interface';

import {
  LOAD_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS,
  LOAD_LM_PENDING_SUBSIDY_SUCCESS,
  LOAD_MEDICAL_LICENCE,
  LOAD_MEDICAL_LICENCE_ASSIGN,
  LOAD_MEDICAL_LICENCE_FAIL,
  LOAD_RR_NO_RIGHT_SUCCESS,
  LOAD_RR_PAYMENT_ERROR_SUCCESS,
  LOAD_RR_REDUCTION_SUCCESS,
  LOAD_RR_REJECTION_SUCCESS,
  LOAD_LM_ASSIGN_SUCCESS,
  LOAD_ALL_MEDICAL_LICENCE,
  LOAD_ALL_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS,
  LOAD_ALL_LM_PENDING_SUBSIDY_SUCCESS,
  LOAD_ALL_RR_REJECTION_SUCCESS,
  LOAD_ALL_RR_REDUCTION_SUCCESS,
  LOAD_ALL_RR_NO_RIGHT_SUCCESS,
  LOAD_ALL_RR_PAYMENT_ERROR_SUCCESS,
  // LOAD_LM_ASSIGN_PARAMETERS_SUCCESS,
} from '@store/actions';

export interface lmRecordState {
  pendiente_contraloria: IMedicalLeave[];
  pendiente_subsidio: IMedicalLeave[];
  rechazo: IMedicalLeave[];
  reduccion: IMedicalLeave[];
  sin_derecho: IMedicalLeave[];
  error_pago: IMedicalLeave[];
  lm_sin_asignar: IMedicalLeave[];
  parametros_asignacion: {};
  usuarios_seleccionados: IUser[];
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const medicalLicencesInitialState: lmRecordState = {
  pendiente_contraloria: [],
  pendiente_subsidio: [],
  rechazo: [],
  reduccion: [],
  sin_derecho: [],
  error_pago: [],
  lm_sin_asignar: [],
  parametros_asignacion: {},
  usuarios_seleccionados: [],
  loaded: false,
  loading: false,
  error: null,
};

const _LmRecordsReducer = createReducer(
  medicalLicencesInitialState,

  on(LOAD_MEDICAL_LICENCE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_ALL_MEDICAL_LICENCE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_MEDICAL_LICENCE_ASSIGN, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    pendiente_contraloria: [...lmRecords],
  })),

  on(LOAD_LM_PENDING_SUBSIDY_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    pendiente_subsidio: [...lmRecords],
  })),
  on(LOAD_RR_REJECTION_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    rechazo: [...lmRecords],
  })),
  on(LOAD_RR_REDUCTION_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    reduccion: [...lmRecords],
  })),
  on(LOAD_RR_NO_RIGHT_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    sin_derecho: [...lmRecords],
  })),
  on(LOAD_RR_PAYMENT_ERROR_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    error_pago: [...lmRecords],
  })),
  on(LOAD_LM_ASSIGN_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    lm_sin_asignar: [...lmRecords],
  })),

  on(LOAD_MEDICAL_LICENCE_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_ALL_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    pendiente_contraloria: [...lmRecords],
  })),

  on(LOAD_ALL_LM_PENDING_SUBSIDY_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    pendiente_subsidio: [...lmRecords],
  })),
  on(LOAD_ALL_RR_REJECTION_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    rechazo: [...lmRecords],
  })),
  on(LOAD_ALL_RR_REDUCTION_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    reduccion: [...lmRecords],
  })),
  on(LOAD_ALL_RR_NO_RIGHT_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    sin_derecho: [...lmRecords],
  })),
  on(LOAD_ALL_RR_PAYMENT_ERROR_SUCCESS, (state, { lmRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    error_pago: [...lmRecords],
  })),
);

export function LmRecordsReducer(state: lmRecordState, action: Action) {
  return _LmRecordsReducer(state, action);
}
//TODO: comentar
